import React from "react";
const Disclaimers = () => (
  <div
    style={{
      maxWidth: 800,
      margin: "2rem auto",
      padding: "2rem",
      background: "#fff",
      color: "#222",
      borderRadius: 12,
      boxShadow: "0 4px 24px #0001",
      fontFamily: "Inter, Arial, sans-serif",
      lineHeight: 1.7,
    }}
  >
    <h1
      style={{
        fontSize: "2.2rem",
        fontWeight: 800,
        marginBottom: "1.5rem",
        color: "#7C3AED",
      }}
    >
      Disclaimer
    </h1>
    <p style={{ color: "#666", fontSize: "1rem", marginBottom: "1.5rem" }}>
      <strong>Last Updated:</strong> October 12, 2025
    </p>

    <h2 style={{ marginTop: "2rem", color: "#A855F7", fontSize: "1.3rem" }}>
      1. Informational Purposes Only
    </h2>
    <p>
      The information provided on this website, including any updates you may
      receive after subscribing, is for general informational purposes only and
      does not constitute:
    </p>
    <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
      <li>an offer to sell,</li>
      <li>a solicitation to buy, or</li>
      <li>
        financial or investment advice with respect to any cryptocurrency,
        digital asset, security, or other financial instrument.
      </li>
    </ul>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      2. Project Status
    </h2>
    <p>
      BitcoinFOMO is an early-stage project in development. Features, timelines,
      and specifications described here are subject to change without notice.
    </p>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      3. No Rights or Guarantees
    </h2>
    <p>
      Participation on the email update list is solely to receive project news
      and does not grant any rights, privileges, or guarantees of future token
      allocations.
    </p>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      4. User Responsibility
    </h2>
    <p>
      Users are responsible for complying with the laws of their jurisdiction
      before engaging in any cryptocurrency activity.
    </p>
  </div>
);
export default Disclaimers;
